import React from 'react';
import CustomersTab from '../organization/venue-booking/CustomersTab';

export default function VenueOwnerCustomersPage() {
  return (
    <div data-testid="venue-owner-customers-page">
      <CustomersTab />
    </div>
  );
}
